import { IoMdHome, IoMdSettings } from 'react-icons/io';
import { MdPersonAddAlt1, MdOutlineNote } from 'react-icons/md';
import { ImClock2 } from 'react-icons/im';
import { FaCalendarAlt } from 'react-icons/fa';
import { RiBookFill } from 'react-icons/ri';
import { TbDoorExit } from 'react-icons/tb';
import { SlQuestion } from 'react-icons/sl';
import { BsPersonFill, BsPersonWorkspace } from 'react-icons/bs';
import { SidebarItem } from '../../types/navigation';
import { HiUserGroup } from 'react-icons/hi';

export const hrmsAdminSidebarConfig: SidebarItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: <IoMdHome size={20} />,
    path: '/:orgSlug/hrms/dashboard',
  },
  {
    id: 'employee-directory',
    label: 'Employee Directory',
    icon: <HiUserGroup size={20} />,
    path: '/:orgSlug/hrms/employees',
  },
  {
    id: 'profile-tracker',
    label: 'Onboarding Queue',
    icon: <MdPersonAddAlt1 size={20} />,
    path: '/:orgSlug/hrms/onboarding-queue',
  },
  {
    id: 'attendance',
    label: 'Attendance',
    icon: <ImClock2 size={18} />,
    path: '/:orgSlug/hrms/attendance',
  },
  {
    id: 'my-workspace',
    label: 'My Workspace',
    icon: <BsPersonWorkspace size={20} />,
    children: [
      {
        id: 'profile',
        label: 'My Details',
        icon: <BsPersonFill size={20} />,
        path: '/:orgSlug/hrms/my-profile',
      },
      {
        id: 'my-attendance',
        label: 'My Attendance',
        icon: <ImClock2 size={18} />,
        path: '/:orgSlug/hrms/my-attendance',
      },
      {
        id: 'my-leave',
        label: 'My Leave',
        icon: <FaCalendarAlt size={20} />,
        path: '/:orgSlug/hrms/my-leave',
      },
    ],
  },

  {
    id: 'leave-management',
    label: 'Leave Management',
    icon: <FaCalendarAlt size={20} />,
    path: '/:orgSlug/hrms/leave',
  },

  {
    id: 'repository',
    label: 'Handbook',
    icon: <RiBookFill size={20} />,
    path: '/:orgSlug/hrms/repository',
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: <IoMdSettings size={20} />,
    path: '/:orgSlug/hrms/settings/attendance-rules',
  },
  // Exit Management hidden until feature is ready
  // {
  //   id: 'exit-management',
  //   label: 'Exit Management',
  //   icon: <TbDoorExit size={18} />,
  //   path: '/:orgSlug/hrms/exit-management',
  // },
];

export const hrmsManagerSidebarConfig = hrmsAdminSidebarConfig.filter(
  (item) => item.id !== 'settings',
);

export const hrmsEmployeeSidebarConfig: SidebarItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: <IoMdHome size={20} />,
    path: '/:orgSlug/hrms/dashboard',
  },
  {
    id: 'attendance',
    label: 'Attendance',
    icon: <ImClock2 size={18} />,
    path: '/:orgSlug/hrms/attendance',
  },
  {
    id: 'profile',
    label: 'My Details',
    icon: <BsPersonFill size={20} />,
    path: '/:orgSlug/hrms/my-profile',
  },
  {
    id: 'handbook',
    label: 'Handbook',
    icon: <RiBookFill size={20} />,
    path: '/:orgSlug/hrms/handbook',
  },
  {
    id: 'leave-management',
    label: 'Leave Management',
    path: '/:orgSlug/hrms/leave',
    icon: <FaCalendarAlt size={20} />,
  },
  // {
  //   id: 'help-support',
  //   label: 'Help & Support',
  //   icon: <SlQuestion size={20} />,
  //   children: [
  //     {
  //       id: 'contact-hr',
  //       label: 'Contact HR',
  //       icon: <MdOutlineNote size={18} />,
  //     },
  //     {
  //       id: 'resignation',
  //       label: 'Resignation',
  //       path: '/:orgSlug/support/resignation',
  //       icon: <MdOutlineNote size={18} />,
  //     },
  //   ],
  // },
];
